import { Link } from 'react-router-dom';
import { useState } from 'react';
import { articles } from '@/mocks/articles';
import SEO from '@/components/feature/SEO';

const categories = ['全部', '企业动态', '行业洞察'];

export default function ArticlesPage() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filteredArticles = activeCategory === '全部'
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  return (
    <>
      <SEO
        title="新闻资讯"
        description="尊龙集团最新企业动态与行业洞察：DDR5量产进展、技术突破、市场分析、人才战略。了解尊龙集团在DRAM存储器领域的最新发展。"
        keywords="尊龙新闻,DRAM行业动态,半导体资讯,存储器技术,尊龙集团动态"
        canonicalPath="/articles"
        ogType="website"
      />

      <main className="pt-16">
        {/* Header */}
        <section className="bg-background-100 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">新闻资讯</p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
              最新动态与行业洞察
            </h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              了解尊龙集团在DRAM存储器领域的最新技术突破、市场动态与战略布局
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="border-b border-background-200/70 bg-background-50 sticky top-16 z-30">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 overflow-x-auto py-2 px-1">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    activeCategory === cat
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200"
                >
                  <div className="h-44 md:h-52 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h2 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.summary}
                    </p>
                    <div className="flex flex-wrap gap-1.5 mt-3">
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          className="text-xs bg-background-100 text-foreground-500 px-2 py-0.5 rounded whitespace-nowrap"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {filteredArticles.length === 0 && (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-article-line text-2xl" />
                </div>
                <p className="text-foreground-500 text-sm">暂无相关文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}